import Column from 'Components/Base/Column'
import ResponsiveContainer from 'Components/Base/ResponsiveContainer'
import Row from 'Components/Base/Row'
import Typography from 'Components/Base/Typography'
import React, { useEffect, useState } from 'react'
import data from 'tria-ui-react-lib/challenges/stepInfo.json'
import { Paragraph, SectionInfo } from 'types/Challenge'

interface Props {
  isMobile: boolean
  step: number
  setInfoPage: (infoPage: boolean) => void
}
export default function HSGStep3({ isMobile, step, setInfoPage }: Props) {
  const [sectionInfo, setSectionInfo] = useState<SectionInfo>()
  const [stepParagraphs, setStepParagraphs] = useState<Paragraph[]>()

  useEffect(() => {
    setInfoPage(true)
    window.scrollTo(0, 0)
    setSectionInfo(
      data.pageInfoBySection.sectionInfo.find(
        (sectionInfo) => sectionInfo.sectionId === parseInt(window.location.pathname.split('/')[window.location.pathname.split('/').length - 2]),
      ),
    )
    setStepParagraphs(
      data.pageInfoBySection.sectionInfo.find(
        (sectionInfo) => sectionInfo.sectionId === parseInt(window.location.pathname.split('/')[window.location.pathname.split('/').length - 2]),
      )?.paragraphs,
    )
  }, [step])

  return (
    <ResponsiveContainer>
      <Column styles={{ margin: isMobile ? '20px auto' : '0px 60px 0px 0px' }}>
        <Row styles={{ margin: isMobile ? '20px auto' : '20px 0px' }}>
          <Typography size={20}>{stepParagraphs?.find((paragraph) => paragraph.paragraphId === 8)?.paragraph ?? ''}</Typography>
        </Row>
        <Row styles={{ margin: isMobile ? '20px auto' : '20px 0px' }}>
          <Typography variant="h1">{sectionInfo?.titles.find((title) => title.titleId === 8)?.titleText ?? ''}</Typography>
        </Row>
        <Row styles={{ margin: isMobile ? '20px auto' : '10px 0px', width: '70%' }}>
          <li></li>
          <p style={{ marginRight: 5, fontFamily: 'Raleway', fontSize: 20 }}>
            <b>{sectionInfo?.titles.find((title) => title.titleId === 9)?.titleText ?? ''}</b>{' '}
            {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 9)?.paragraph ?? ''}
          </p>
        </Row>
        <Row styles={{ margin: isMobile ? '20px auto' : '10px 0px', width: '70%' }}>
          <li></li>
          <p style={{ marginRight: 5, fontFamily: 'Raleway', fontSize: 20 }}>
            <b>{sectionInfo?.titles.find((title) => title.titleId === 10)?.titleText ?? ''}</b>{' '}
            {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 10)?.paragraph ?? ''}
          </p>
        </Row>
        <Row styles={{ margin: isMobile ? '20px auto' : '10px 0px', width: '70%' }}>
          <li></li>
          <p style={{ marginRight: 5, fontFamily: 'Raleway', fontSize: 20 }}>
            <b>{sectionInfo?.titles.find((title) => title.titleId === 11)?.titleText ?? ''}</b>{' '}
            {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 11)?.paragraph ?? ''}
          </p>
        </Row>
        <Row styles={{ margin: isMobile ? '20px auto' : '10px 0px', width: '70%' }}>
          <li></li>
          <p style={{ marginRight: 5, fontFamily: 'Raleway', fontSize: 20 }}>
            <b>{sectionInfo?.titles.find((title) => title.titleId === 12)?.titleText ?? ''}</b>{' '}
            {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 12)?.paragraph ?? ''}
          </p>
        </Row>
        <Row styles={{ margin: isMobile ? '20px auto' : '10px 0px', width: '70%' }}>
          <li></li>
          <p style={{ marginRight: 5, fontFamily: 'Raleway', fontSize: 20 }}>
            <b>{sectionInfo?.titles.find((title) => title.titleId === 13)?.titleText ?? ''}</b>{' '}
            {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 13)?.paragraph ?? ''}
          </p>
        </Row>
      </Column>
      <Column styles={{ width: '100%', marginTop: isMobile ? '0px' : '40px' }}>
        <img
          src={sectionInfo?.images.find((image) => image.imageId === 3)?.url}
          alt="scale"
          style={{ width: isMobile ? '100%' : '318px', marginLeft: 'auto', marginTop: 10 }}
        />
        <img
          src={sectionInfo?.images.find((image) => image.imageId === 4)?.url}
          alt="scale"
          style={{ width: isMobile ? '100%' : '318px', marginLeft: 'auto', marginTop: 10 }}
        />
        <img
          src={sectionInfo?.images.find((image) => image.imageId === 5)?.url}
          alt="scale"
          style={{ width: isMobile ? '100%' : '318px', marginLeft: 'auto', marginTop: 10 }}
        />
        <img
          src={sectionInfo?.images.find((image) => image.imageId === 6)?.url}
          alt="scale"
          style={{ width: isMobile ? '100%' : '318px', marginLeft: 'auto', marginTop: 10 }}
        />
        <img
          src={sectionInfo?.images.find((image) => image.imageId === 7)?.url}
          alt="scale"
          style={{ width: isMobile ? '100%' : '318px', marginLeft: 'auto', marginTop: 10 }}
        />
      </Column>
    </ResponsiveContainer>
  )
}
